<template>
    <!--在线投诉页面-->

    <div class="wrapper">
        <Header ref="header"></Header>

        <!--提交表单-->
        <div class="content-wrap">
            <div class="content-left">
                <div class="reminder">
                    <img src="../assets/image/tousu-icon.png" alt>
                    <span class="online1">在线投诉</span>
                    <span class="online2">(注：您填写的信息越详细，越有利于您投诉问题的尽快和解)</span>
                </div>
                <div class="info">
                    <div class="consumer-title">消费者信息</div>
                    <div class="consumer-input">
                        <div class="form">
                            <label>
                                案例编号：
                                <el-input
                                        style="width:450px; margin-left:8px;"
                                        type="text"
                                        placeholder="    请输入案例编号"
                                        v-model="form.order_code"
                                        disabled
                                />
                            </label>
                            <br>
                            <label>
                                <span style="color:red">*</span>投诉人姓名：
                                <el-input
                                        style="width:450px; margin-left:8px;"
                                        type="text"
                                        placeholder="    请输入您的姓名"
                                        v-model="form.c_realname"
                                />
                            </label>
                            <br>
                            <label>
                                投诉人地址：
                                <el-input
                                        style="width:450px; margin-left:8px;"
                                        type="text"
                                        placeholder="    请输入您的地址"
                                        v-model="form.c_address"
                                />
                            </label>
                            <br>
                            <label>
                                <span style="color:red">*</span>投诉人电话：
                                <el-input
                                        style="width:450px; margin-left:8px;"
                                        type="text"
                                        placeholder="    请输入您的电话"
                                        v-model="form.c_mobile"
                                />
                            </label>
                            <br>
                            <label>
                                投诉人邮箱：
                                <el-input
                                        style="width:450px; margin-left:8px;"
                                        type="text"
                                        placeholder="    请输入您的邮箱"
                                        v-model="form.c_email"
                                />
                            </label>
                            <br>
                        </div>
                    </div>
                </div>
                <div class="info">
                    <div class="consumer-title" style="top:15px">被投诉方信息</div>
                    <div class="consumer-input">
                        <div class="form">
                            <label>
                                <span style="color:red">*</span>被投诉方名称：
                                <el-input
                                        style="width:450px; margin-left:8px;"
                                        type="text"
                                        placeholder="    请输入被投诉方名称"
                                        v-model="form.g_realname"
                                />
                            </label>
                            <br>

                            <label>
                                社会信用代码：
                                <el-input
                                        style="width:450px; margin-left:8px;"
                                        type="text"
                                        placeholder="    请输入社会信用代码"
                                        v-model="form.credit_code"
                                />
                            </label>
                            <br>
                            <label>
                                <span style="color:red">*</span>被投诉方地址：
                                <el-input
                                        style="width:450px; margin-left:8px;"
                                        type="text"
                                        placeholder="    请输入投诉方地址"
                                        v-model="form.g_address"
                                />
                            </label>
                            <br>
                            <label>
                                <span style="color:red">*</span>被投诉方联系人：
                                <el-input
                                        style="width:450px; margin-left:8px;"
                                        type="text"
                                        placeholder="    请输入被投诉方联系人"
                                        v-model="form.g_contact"
                                />
                            </label>
                            <br>
                            <label>
                                <span style="color:red">*</span>被投诉方电话：
                                <el-input
                                        style="width:450px; margin-left:8px;"
                                        type="text"
                                        placeholder="    请输入被投诉方电话"
                                        v-model="form.g_mobile"
                                />
                            </label>
                            <br>
                        </div>
                    </div>
                </div>
                <div class="info">
                    <div class="consumer-title">投诉内容</div>
                    <div class="consumer-input">
                        <div class="form">
                            <label style="margin-right:225px">
                                <span style="color:red">*</span>投诉地区：
                                <el-select v-model="complainLocation" placeholder="请选择">
                                    <el-option v-for="item in location" :key="item" :label="item"
                                               :value="item"></el-option>
                                </el-select>
                            </label>
                            <br>

                            <label style="margin-right:225px">
                                <span style="color:red">*</span>投诉类别：
                                <!--<input type="text" placeholder="    请输入投诉类别" v-model="form.types"/>-->
                                <el-select v-model="complainTypes" placeholder="请选择">
                                    <el-option
                                            v-for="item in cateMsg"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                    ></el-option>
                                </el-select>
                            </label>
                            <br>
                            <label>
                                <span style="color:red">*</span>投诉内容标题：
                                <el-input
                                        style="width:440px; margin-left:8px;"
                                        type="text"
                                        placeholder="    请输入投诉内容标题"
                                        v-model="form.title"
                                />
                            </label>
                            <br>
                            <label>
                <span style="position: absolute;left:143px;top:233px;">
                  <span style="color:red">*</span>投诉内容描述：
                </span>
                                <textarea
                                        class="miaoshu"
                                        v-model="form.detail"
                                        placeholder="1.事件经过（时间、地点、人物及纠纷的起因、经过、结果）
2.受损情况。
3.与被投诉方沟通过程。"
                                ></textarea>
                            </label>
                            <br>
                            <label>
                <span style="position: absolute;left:175px;top:377px;">
                  <span style="color:red">*</span>投诉要求：
                </span>
                                <textarea class="miaoshu" placeholder="希望本投诉如何解决" v-model="form.demand"></textarea>
                            </label>
                            <br>
                        </div>
                    </div>
                </div>
                <div class="info">
                    <div class="consumer-title">投诉证据</div>
                    <div class="consumer-input">
                        <div class="form">
                            <div class="form-item">
                                <div class="name">图片证据（图片不大于10MB）</div>
                                <div class="input clearfix mar-30">
                                    <div class="file-box" v-for="(img, index) in form.images" :key="index">
                                        <img :src="qiniuDomain + img">
                                        <label @click="delImg1(index)">
                                            <img src="../assets/image/icon_close.png" alt>
                                        </label>
                                    </div>
                                    <div class="file-box" v-for="(img, index) in imgArr" :key="index">
                                        <img :src="img.img">
                                        <label @click="delImg(index)">
                                            <img src="../assets/image/icon_close.png" alt>
                                        </label>
                                    </div>
                                    <div class="file-box" v-show="imgArr.length < 3">
                                        <img src="../assets/image/icon_add.png">
                                        <input
                                                type="file"
                                                accept="image/*"
                                                multiple="multiple"
                                                @change="getPickerImg($event)"
                                        >
                                    </div>
                                </div>
                            </div>
                            <div class="form-item">
                                <div class="name">录音证据（音频不大于10MB）</div>
                                <div class="input clearfix mar-30">
                                    <div class="file-box" v-for="(audio, index) in form.sound_record" :key="index">
                                        <img src="../assets/image/icon_voice.png">
                                        <label @click="delAudio1(index)">
                                            <img src="../assets/image/icon_close.png" alt>
                                        </label>
                                    </div>
                                    <div class="file-box" v-for="(audio, index) in audioArr" :key="index">
                                        <img src="../assets/image/icon_voice.png">
                                        <label @click="delAudio(index)">
                                            <img src="../assets/image/icon_close.png" alt>
                                        </label>
                                    </div>
                                    <div class="file-box" v-show="audioArr.length < 2">
                                        <img src="../assets/image/icon_add.png" alt>
                                        <input
                                                type="file"
                                                accept="audio/*"
                                                multiple="multiple"
                                                @change="getPickerAudio($event)"
                                        >
                                    </div>
                                </div>
                            </div>
                            <div class="form-item">
                                <div class="name">视频证据（视频不大于100MB）</div>
                                <div class="input clearfix mar-30">
                                    <div class="file-box" v-for="(video, index) in form.videos" :key="index">
                                        <img src="../assets/image/icon_video.png">
                                        <label @click="delVideo1(index)">
                                            <img src="../assets/image/icon_close.png" alt>
                                        </label>
                                    </div>
                                    <div class="file-box" v-for="(video, index) in videoArr" :key="index">
                                        <img src="../assets/image/icon_video.png">
                                        <label @click="delVideo(index)">
                                            <img src="../assets/image/icon_close.png" alt>
                                        </label>
                                    </div>
                                    <div class="file-box" v-show="videoArr.length < 2">
                                        <img src="../assets/image/icon_add.png" alt>
                                        <input
                                                type="file"
                                                accept="video/*"
                                                multiple="multiple"
                                                @change="getPickerVideo($event)"
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tijiao">
                    <el-button
                            style="width:120px;background: #eeb45a;"
                            @click="submitValidate(0)"
                            type="primary"
                    >
                        <!--submitValidate-->
                        提交投诉
                    </el-button>
                    <el-button
                            v-show="draftBtn"
                            style="width:120px;background: #294B7F;color:white;"
                            type="submit"
                            @click="submitValidate(1)"
                    >保存草稿
                    </el-button>
                </div>
            </div>
            <div class="content-right">
                <div class="complain-content">
                    <div class="notice-title">
                        <span style="color:#D0021B">—</span> 和解须知
                        <span style="color:#D0021B">—</span>
                    </div>
                    <div class="notice" v-html="precautions"></div>
                </div>

                <!--广告-->
                <div style="margin:20px 0;" v-if="art3.logo">
                    <a art3.dirlink target="_blank" v-if="art3.type&&art3.type===1">
                        <object data type>
                            <embed :src="art3.logo" type style="width:380px;height:100px">
                        </object>
                    </a>
                    <a :href="art3.dirlink" target="_blank">
                        <img style="width:380px;height:100px" :src="art3.logo" alt>
                    </a>
                </div>
                <Ranking :type="2" title="和解榜" :list="peace"></Ranking>
            </div>
        </div>

        <qiniu-upload ref="qiniuUpload"></qiniu-upload>
        <HomeFoot></HomeFoot>

        <el-dialog
                title="提示"
                :visible.sync="centerDialogVisible"
                :close-on-click-modal="false"
                :show-close="false"
                width="40%"
                center
        >
            <p>您已以游客身份提交成功，如需及时查看投诉和解进展，请注册；</p>
            <p>
                如果不注册，请牢记投诉编号：
                <span style="color:red;font-weight:400;">{{caseCode}}</span>，以便随后查询。
            </p>
            <p>本条投诉通过审核后将显示在“投诉榜”内，欢迎转发。</p>
            <span slot="footer" class="dialog-footer">
        <el-button @click="overlook">忽略</el-button>
        <el-button type="primary" @click="showSignUp">注册</el-button>
      </span>
        </el-dialog>
    </div>
</template>


<script>
  import Header from "@/components/Header.vue";
  import HomeFoot from "@/components/HomeFoot.vue";
  import QiniuUpload from "@/components/QiniuUpload";
  import Ranking from "@/components/Ranking";

  export default {
    name: "ComplainOnline",
    components: {
      Header,
      HomeFoot,
      QiniuUpload,
      Ranking
    },
    data() {
      return {
        precautions: '', // 须知
        form: {
          token: "",
          order_code: "",
          c_realname: "",
          c_mobile: "",
          c_address: "",
          c_email: "",
          credit_code: "",
          g_realname: "",
          g_address: "",
          g_contact: "",
          g_mobile: "",
          area: "",
          title: "",
          types: "",
          detail: "",
          demand: "",
          images: [],
          videos: [],
          sound_record: []
        },
        files: [],
        leader_board: "",
        peace: "",
        comment: "",
        imgArr: [],
        audioArr: [],
        videoArr: [],
        fileArr: [],
        qiniuDomain: "",
        location: "", //投诉地区
        cate: "", //投诉类别
        complainLocation: "",
        complainTypes: "",
        cateMsg: "",
        art3: "",
        centerDialogVisible: false, //点击投诉之后的弹窗
        saveRemark: false,
        report_id: "",
        draftBtn: true, //控制保存草稿是否显示
        caseCode: ""
      };
    },
    mounted() {
      this.getPrecautions()
      this.getCrunchies();
      this.examine();
      this.getlocation();
      this.getCreatedCode();
      this.getGuangGao();
      // 每次刷新页面都跳转到页面顶部
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    watch: {
      'form': {
        handler: function () {
            this.form.c_mobile = this.form.c_mobile.replace(/[^\d\-]/g, '')
            this.form.g_mobile = this.form.g_mobile.replace(/[^\d\-]/g, '')
        },
        deep: true    //深度监听
      },
    },
    methods: {
      // 获取须知
      getPrecautions() {
        this.$get("https://315sd.0532.name/index/complaint/precautions")
          .then(res => {
            if (res.code === 0) {
              this.precautions = res.data
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      getGuangGao() {
        this.$get("https://315sd.0532.name/api/general/new_hot")
          .then(res => {
            if (res.code === 0) {
              this.art3 = res.data.ad3;
              // console.log(res.data, '广告看一下吧')
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      examine() {
        // if (!localStorage.getItem('token')) {
        //   this.$refs.header.showLoginWrap()
        // } else {
        this.form.token = localStorage.getItem("token");
        if (!this.form.token) {
          this.draftBtn = false;
        }
        // }
      },
      // 获取案例编号
      getCreatedCode() {
        let token = localStorage.getItem("token");
        this.$post("/index/complaint/create_code", {token: token})
          .then(res => {
            if (res.code === 0) {
              if (res.data.status) {
                this.form.area = res.data.info.area;
                this.form.c_address = res.data.info.area;
                this.form.c_email = res.data.info.c_email;
                this.form.c_mobile = res.data.info.c_mobile;
                this.form.c_realname = res.data.info.c_realname;
                this.form.demand = res.data.info.demand;
                this.form.detail = res.data.info.detail;
                this.form.g_address = res.data.info.g_address;
                this.form.g_contact = res.data.info.g_contact;
                this.form.g_mobile = res.data.info.g_mobile;
                this.form.g_realname = res.data.info.g_realname;
                this.form.is_draft = res.data.info.is_draft;
                this.form.order_code = res.data.info.order_code;
                this.form.title = res.data.info.title;
                this.form.token = res.data.info.token;
                this.form.types_cate = res.data.info.types_cate;
                this.form.videos = res.data.videos;
                this.form.images = res.data.images;
                this.form.sound_record = res.data.sound_record;

                this.complainLocation = this.form.area;
                this.complainTypes = this.form.types_cate;
              }
              this.form.order_code = res.data.code;
              this.caseCode = this.form.order_code;
              this.qiniuDomain = res.data.qiniu_domain;
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      // 获取地区
      getlocation() {
        this.$get("https://315sd.0532.name/index/complaint/get_cate")
          .then(res => {
            if (res.code === 0) {
              this.location = res.data.area;
              this.cateMsg = res.data.cate;
              // res.data.cate.map((item) => {
              //   this.cate.push(item.name)
              //   this.cateId.push(item.id)
              // })
              console.log(this.cateMsg, "投诉类别");
              this.form.area = this.location;
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      submitValidate(type) {
        this.form.is_draft = type;
        this.form.area = this.complainLocation;
        this.form.types = this.complainTypes;
        // if (!this.form.c_mobile) {
        //   this.$message("请输入投诉人电话")
        //   return true
        // }
        //
        // if (!this.form.g_realname) {
        //   this.$message("请输入被投诉方名称")
        //   return true
        // }
        // if (!this.form.g_address) {
        //   this.$message("请输入被投诉地址")
        //   return true
        // }
        // if (!this.form.area) {
        //   this.$message("请输入投诉地区")
        //   return true
        // }
        // if (!this.form.types) {
        //   this.$message("请输入投诉类别")
        //   return true
        // }
        // if (!this.form.title) {
        //   this.$message("请输入投诉内容标题")
        //   return true
        // }
        // if (!this.form.detail) {
        //   this.$message("请输入投诉内容描述")
        //   return true
        // }
        // if (!this.form.demand) {
        //   this.$message("请输入投诉投诉要求")
        //   return true
        // }
        this.uploadFile();
      },
      overlook() {
        this.centerDialogVisible = false;
        this.form = [];
        this.files = [];
        this.leader_board = "";
        this.peace = "";
        this.comment = "";
        this.imgArr = [];
        this.audioArr = [];
        this.videoArr = [];
        this.fileArr = [];
        this.qiniuDomain = "";
        // this.location = '' //投诉地区
        this.complainLocation = "";
        this.complainTypes = "";
        // this.cateMsg = ''//投诉类别

        this.$router.push({
          path: "/ComplainView",
          query: {id: 1, title: "投诉榜"}
        });
      },
      submitData() {
        this.form.token = localStorage.getItem("token");
        this.$post("https://315sd.0532.name/index/complaint/post_data", this.form)
          .then(res => {
            if (res.code === 0) {
              if (!res.data.is_login) {
                localStorage.setItem("report_id", res.data.report_id);

                this.centerDialogVisible = true;
              } else {
                if (!this.form.is_draft && this.form.token) {
                  this.$message({
                    message: "提交成功,如需查看最新进度,请前往投诉和消息中心",
                    type: "success"
                  });
                  this.overlook();
                } else {
                  this.$message({
                    message: res.msg,
                    type: "success"
                  });
                }
              }

              this.imgArr = [];
              this.audioArr = [];
              this.videoArr = [];
              this.fileArr = [];
              //如果用户未登录
            } else {
              this.$message({
                message: res.msg,
                type: "warning"
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      showSignUp() {
        this.$refs.header.showSign = true;
        this.$refs.header.SignIn.report_id = this.report_id;
        this.centerDialogVisible = false;
        console.log("id未注册", this.$refs.header.SignIn.report_id);
      },
      // gohome() {
      //   this.$router.go(-1)
      // },
      // 获取投诉排行
      getCrunchies() {
        this.$get("/index/index/center_article")
          .then(res => {
            if (res.code === 0) {
              this.leader_board = res.data.leader_board;
              this.peace = res.data.peace;
              this.comment = res.data.comment;
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      // 上传文件到七牛云
      uploadFile: function () {
        let qiniu = this.$refs.qiniuUpload;
        for (let i = 0; i < this.imgArr.length; i++) {
          this.fileArr.push(this.imgArr[i].file);
        }
        for (let i = 0; i < this.audioArr.length; i++) {
          this.fileArr.push(this.audioArr[i]);
        }
        for (let i = 0; i < this.videoArr.length; i++) {
          this.fileArr.push(this.videoArr[i]);
        }
        qiniu.qiniuUpload(this.fileArr, res => {
          for (let i in res) {
            if (res[i].mimeType.includes("image")) {
              this.form.images.push(res[i].key);
            } else if (res[i].mimeType.includes("audio")) {
              this.form.sound_record.push(res[i].key);
            } else if (res[i].mimeType.includes("video")) {
              this.form.videos.push(res[i].key);
            }
          }
          this.submitData();
        });
      },
      // 获取图片
      getPickerImg: function (e) {
        let files = e.target.files;
        for (let i = 0; i < files.length; i++) {
          if (files[i].size < 10240000) {
            let img = {};
            img.file = files[i];
            let reader = new FileReader();
            reader.readAsDataURL(files[i]);
            reader.onload = evt => {
              img.img = evt.target.result;
              if (this.imgArr.length < 3) {
                this.imgArr.push(img);
              } else {
                this.$layer.toast("最多只能选择3张图片");
                this.$message({
                  message: "最多只能选择3张图片",
                  type: "warning"
                });
              }
            };
          } else {
            this.$layer.toast("请上传不大于10MB的图片");
          }
        }
        e.target.value = "";
      },
      // 删除图片
      delImg: function (index) {
        this.imgArr.splice(index, 1);
      },
      delImg1: function (index) {
        this.form.images.splice(index, 1);
      },
      // 获取音频
      getPickerAudio: function (e) {
        let files = e.target.files;
        for (let i = 0; i < files.length; i++) {
          if (files[i].size < 10072000) {
            if (this.audioArr.length < 2) {
              this.audioArr.push(files[i]);
            } else {
              this.$layer.toast("最多只能选择2个音频");
            }
          } else {
            this.$layer.toast("请上传不大于10MB的音频");
          }
        }
        e.target.value = "";
      },
      // 删除音频
      delAudio: function (index) {
        this.audioArr.splice(index, 1);
      },
      delAudio1: function (index) {
        this.form.sound_record.splice(index, 1);
      },
      // 获取视频
      getPickerVideo: function (e) {
        let files = e.target.files;
        for (let i = 0; i < files.length; i++) {
          if (files[i].size < 102400000) {
            if (this.videoArr.length < 2) {
              this.videoArr.push(files[i]);
            } else {
              this.$layer.toast("最多只能选择2个音频");
            }
          } else {
            this.$layer.toast("请上传不大于100MB的视频");
          }
        }
        e.target.value = "";
      },
      // 删除视频
      delVideo: function (index) {
        this.videoArr.splice(index, 1);
      },
      delVideo1: function (index) {
        this.form.videos.splice(index, 1);
      }
    },

  };
</script>

<style scoped lang="less">
    label > input {
    }

    .reminder {
        width: 786px;
        height: 64px;
        margin: 0 auto;
        border: 1px solid #eeb45a;
        background: #ffefd7;
        margin-top: 56px;
        margin-bottom: 24px;

        img {
            width: 24px;
            height: 24px;
            padding-left: 32px;
        }

        .online1 {
            height: 64px;
            font-size: 18px;
            font-family: MicrosoftYaHei-Bold;
            font-weight: bold;
            color: rgba(208, 2, 27, 1);
            line-height: 64px;
        }

        .online2 {
            height: 64px;
            font-size: 18px;
            font-family: MicrosoftYaHei-Bold;
            font-weight: bold;
            color: #716f6e;
            line-height: 64px;
        }
    }

    .info {
        width: 786px;
        margin: 0 auto;
        position: relative;
        padding-bottom: 16px;

        .consumer-title {
            position: absolute;
            top: 38px;
            left: 28px;
            height: 21px;
            font-size: 18px;
            font-family: MicrosoftYaHei-Bold;
            font-weight: bold;
            color: rgba(102, 102, 102, 1);
            line-height: 21px;
        }
    }

    .consumer-input {
        border: 1px solid #eeb75e;
        box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.75);

        .form {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            margin-top: 40px;
            margin-right: 85px;
        }

        input {
            width: 438px;
            height: 32px;
            outline: none;
            -webkit-appearance: none;
            border-radius: 0;
            border: 1px solid #979797;
            border-radius: 3px;
            background: #f3f3f3;
        }
    }

    .tijiao {
        width: 785px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
    }

    .submit {
        width: 80px;
        height: 32px;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: rgba(255, 255, 255, 1);
        line-height: 32px;
        -webkit-appearance: none;
        border-radius: 2px;
        margin: 0;
        padding: 0;
        border: 1px solid transparent; //自定义边框
        outline: none;
        background: #1890ff;
        color: rgb(255, 255, 255);
    }

    .reseta {
        width: 80px;
        height: 32px;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        line-height: 32px;
        -webkit-appearance: none;
        border-radius: 2px;
        margin: 0;
        padding: 0;
        border: 1px solid transparent; //自定义边框
        outline: none;
        margin-left: 10px;
    }

    .miaoshu {
        border: 1.5px solid #f3f3f3;
        border-radius: 5px;
        background-color: white;
        width: 420px;
        height: 100px;
        padding: 10px;
        resize: none;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: rgba(153, 153, 153, 1);
        line-height: 22px;
        margin-left: 10px;
    }

    .complain-content {
        width: 370px;
        margin-bottom: 20px;
        border: 1px solid #f3f3f3;
        background: #f3f3f3;
    }

    .content-wrap {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
    }

    .notice {
        width: 332px;
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 21px;
        margin: 0 auto;

        p {
            margin: 0;
            padding: 0;
        }
    }

    .notice-title {
        width: 332px;
        text-align: center;
        margin-bottom: 14px;
        margin-top: 18px;
        font-size: 16px;
        font-family: MicrosoftYaHei-Bold;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 21px;
    }

    .form-item {
        width: 450px;
        padding: 30px 0;
        border-bottom: solid #dbdbdb 1px; /*no*/

        .name {
            color: #666;
            font-size: 16px;
            line-height: 2;

            i {
                color: #d0021b;
            }
        }

        .input {
            input {
                display: block;
                width: 100%;
                height: 40px;
                color: #333;
                font-size: 30px;
                line-height: 40px;
                border: none;
                outline: medium;
                text-align: right;
            }

            select {
                display: block;
                width: 100%;
                height: 40px;
                color: #333;
                font-size: 30px;
                line-height: 40px;
                border: none;
                outline: medium;
                text-align: right;
                direction: ltr;
            }

            textarea {
                width: 100%;
                box-sizing: border-box;
                color: #333;
                font-size: 30px;
                line-height: 1.6;
                padding: 20px;
                border: none;
                outline: medium;
                background-color: #f8f8f8;
                margin-top: 30px;
                border-radius: 6px;
            }

            .file-box {
                width: 120px;
                height: 120px;
                margin-right: 30px;
                float: left;
                position: relative;

                img {
                    display: block;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }

                input[type="file"] {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    opacity: 0;
                    z-index: 1;
                }

                label {
                    display: block;
                    height: 40px;
                    width: 40px;
                    position: absolute;
                    top: -10px;
                    right: -16px;
                    z-index: 2;

                    img {
                        display: block;
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
        }
    }

    .content-right {
        margin-top: 55px;
    }

    .mar-30 {
        margin-top: 30px;
    }
</style>
